import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";

export function SignIn() {
  const handleSignIn = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      console.error("sign-in failed", err);
    }
  };

  return (
    <button
      onClick={handleSignIn}
      className="sign-in-button"
    >
      Continue with Google <span aria-hidden="true">→</span>
    </button>
  );
}
